export const SET_IS_REDEEMING_REWARDS = 'SET_IS_REDEEMING_REWARDS';
export const SET_REDEEMING_REWARDS_STATUS = 'SET_REDEEMING_REWARDS_STATUS';
export const CLEAR_REWARDS_TRANSPARENCY_POINTS_FOR_ALL = 'CLEAR_REWARDS_TRANSPARENCY_POINTS_FOR_ALL';
export const STORE_REWARDS_TRANSPARENCY_POINTS_FOR_ITEM = 'STORE_REWARDS_TRANSPARENCY_POINTS_FOR_ITEM';
export const STORE_REWARDS_TRANSPARENCY_POINTS_FOR_CART = 'STORE_REWARDS_TRANSPARENCY_POINTS_FOR_CART';
export const STORE_REWARDS_TRANSPARENCY_POINTS_FOR_BRAND = 'STORE_REWARDS_TRANSPARENCY_POINTS_FOR_BRAND';
export const LOOKUP_REWARDS_TRANSPARENCY_POINTS_FOR_ITEM = 'LOOKUP_REWARDS_TRANSPARENCY_POINTS_FOR_ITEM';
export const LOOKUP_VIP_POINT_ACTIVITY = 'LOOKUP_VIP_POINT_ACTIVITY';
export const STORE_VIP_POINT_ACTIVITY = 'STORE_VIP_POINT_ACTIVITY';
